<div (mouseenter)="toggleEditMode()" (mouseleave)="toggleEditMode()" class="editable-container">

  <div [ngStyle]="containerStyles()">

    <ng-content></ng-content>

  </div>
  <ng-container *ngIf="editMode && editModeEnabled">
    <span class="material-symbols-outlined edit-button" icon="mode_edit" *allowRole="['ADMIN']"
      (click)="onEditClicked()">
      edit
    </span>
  </ng-container>

</div>